import {
  Dialog,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { Delete } from "@mui/icons-material";
import ConfirmationModal from "../../../App/Components/Modals/ConfirmationModal";
import { callAPI } from "../../../App/Helpers/callApi";
import Signifier from "../../../App/Components/Signifier/Signifier";
import { Link } from "react-router-dom";
import { deleteEventVenue, getEventVenues } from "../EventVenuesService";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  image: {
    maxWidth: "100px",
    height: "auto",
  },
  tableCell: {
    color: theme.palette.primary.copy,
  },
}));

export default function EventVenueTableCell({
  columns,
  element,
  index,
  setTableData,
}) {
  const classes = useStyles();
  const [deleteModal, setDeleteModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  const callDeleteVenue = () => {
    callAPI(
      deleteEventVenue(element.id),
      "Venue Deleted",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getEventVenues(element.clientId).then((response) => {
        setTableData(response);
      });
    });
  };

  function openModal(e) {
    e.preventDefault();
    setDeleteModal(true);
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <TableRow
        hover
        className={index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={index}
        component={Link}
        to={{ pathname: "/eventvenues/eventvenuedetailed", state: element }}
      >
        {columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "Delete" ? (
              <Tooltip title="Delete Featured Event">
                <IconButton onClick={(e) => openModal(e)} size="large">
                  <Delete />
                </IconButton>
              </Tooltip>
            ) : column.label === "Logo" ? (
              <img className={classes.image} src={element[column.propName]} />
            ) : (
              element[column.propName]
            )}
          </TableCell>
        ))}
      </TableRow>
      <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
        <ConfirmationModal
          question="Delete this event venue?"
          func={() => callDeleteVenue()}
          closeModal={() => setDeleteModal(false)}
        />
      </Dialog>
    </>
  );
}
